/**
 * A transient time message (spec 35).
 *
 * Deliberately encouraging rather than warning: the goal is to reduce abandonment by showing the
 * end is close, not to make anyone feel rushed. Amber only in the last five minutes.
 */
import React from 'react';
import { Clock, Sparkles } from 'lucide-react';

interface TimerNudgeProps {
  message: string | null;
  urgent: boolean;
}

const TimerNudge: React.FC<TimerNudgeProps> = ({ message, urgent }) => {
  const tone = urgent
    ? 'bg-amber-50 border-amber-200 text-amber-800'
    : 'bg-blue-50 border-blue-200 text-blue-900';
  const Icon = urgent ? Clock : Sparkles;

  // The live region stays mounted even with nothing to say. A region that appears together with
  // its first message is not reliably announced — the nudge would then be visible to everyone
  // except the people who most need it read out.
  return (
    <div role="status">
      {message && (
        <div className={`flex items-start gap-3 mt-4 mb-4 px-4 py-3 rounded-xl border ${tone}`}>
          <Icon className="w-4 h-4 mt-0.5 flex-none" aria-hidden="true" />
          <p className="text-sm font-semibold leading-snug">{message}</p>
        </div>
      )}
    </div>
  );
};

export default TimerNudge;
